import React from "react";
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const AGE_COLORS = ["#93C5FD", "#3B82F6", "#1D4ED8", "#E11D48"];

export const Panel = ({ title, sub, children, testid, right }) => (
  <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid={testid}>
    <div className="flex items-start justify-between gap-2 mb-3">
      <div><div className="text-sm font-semibold text-slate-900">{title}</div>{sub && <div className="text-[11px] text-slate-500">{sub}</div>}</div>
      {right}
    </div>
    {children}
  </div>
);

export const AgingChart = ({ data }) => (
  <Panel title="Open inquiry age" sub="Days since the inquiry date" testid="ov-aging">
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} margin={{ left: -20, right: 8 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
        <XAxis dataKey="bucket" tick={{ fontSize: 11 }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
        <Tooltip cursor={{ fill: "#EFF6FF" }} />
        <Bar dataKey="count" name="Inquiries" radius={[3, 3, 0, 0]}>
          {data.map((d, i) => <Cell key={d.bucket} fill={AGE_COLORS[i]} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </Panel>
);

export const ClosureChart = ({ data }) => {
  const max = Math.max(1, ...data.map((d) => d.count));
  return (
    <Panel title="Closure reasons" sub="Why closed inquiries did not proceed" testid="ov-closure">
      {data.length === 0 ? <div className="text-sm text-slate-500 py-10 text-center" data-testid="ov-closure-empty">No closed inquiries in this view.</div> : (
        <ul className="space-y-2.5">
          {data.map((d) => (
            <li key={d.reason} data-testid={`ov-closure-${d.reason}`}>
              <div className="flex justify-between text-xs mb-1"><span className="text-slate-700">{d.reason}</span><span className="mono text-slate-900">{d.count}</span></div>
              <div className="h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-slate-500 rounded-full transition-[width] duration-500" style={{ width: `${(d.count * 100) / max}%` }} /></div>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};
